import React, { useRef, useState, useEffect, useMemo } from "react";
import * as THREE from "three";
import { useFrame } from "@react-three/fiber";
import { useGLTF } from "@react-three/drei";
import useUiStore from "../../../stores/useUiStore";

export default function ModelPreview(props) {
  const { filename, hovered, cellSize, rotationFragment } = props;

  const { paramsFragments } = useUiStore();

  var pathToModel = `/modeles/${filename}/5K/${filename}.glb`;
  var pathToDraco = "/draco/";

  const matRef = useRef();
  const meshRef = useRef();
  const myScaleRef = useRef();
  // let myScale;

  const orange = new THREE.Color("orange");
  const goldenrod = new THREE.Color("goldenrod");
  const gold = new THREE.Color("gold");
  const yellow = new THREE.Color("yellow");
  const white = new THREE.Color("white");
  const navajowhite = new THREE.Color("navajowhite");

  const vecScaleInit = new THREE.Vector3();
  const vecScaleFill = new THREE.Vector3();

  const [rotX, rotY, rotZ] = rotationFragment.map((item) =>
    THREE.MathUtils.degToRad(item)
  );

  useEffect(() => {
    const bbox = new THREE.Box3().setFromObject(meshRef.current);
    const bboxSize = new THREE.Vector3();
    const { x, y, z } = bbox.getSize(bboxSize);
    const maxSize = Math.max(x, y, z);
    const coef = 0.6;
    // myScale = (cellSize / maxSize) * coef;
    myScaleRef.current = (cellSize / maxSize) * coef;
    const scale = (cellSize / maxSize) * coef;
    paramsFragments?.scaled?.value
      ? meshRef.current.scale.setScalar(1)
      : meshRef.current.scale.setScalar(scale);
  }, [paramsFragments?.scaled?.value]);

  // Loader
  const model = useGLTF(pathToModel, pathToDraco);
  const { nodes, materials } = model;

  const listMeshes = Object.values(nodes).filter((node) => node.isMesh);
  const material = Object.values(materials).find((mat) => mat.isMaterial);
  material.name = `${filename}_5K_mat`;

  useFrame((state, delta) => {
    // color
    matRef.current.color.lerp(hovered ? navajowhite : white, 0.3);

    // console.log(meshRef.current.rotation.y / (Math.PI * 2));

    // rotation
    paramsFragments?.animated?.value
      ? (meshRef.current.rotation.y += delta / 12)
      : (meshRef.current.rotation.y = THREE.MathUtils.lerp(
          meshRef.current.rotation.y,
          Math.round(meshRef.current.rotation.y / (Math.PI * 2)) * Math.PI * 2,
          0.05
        ));

    // scale
    // meshRef.current.scale.x =
    //   meshRef.current.scale.y =
    //   meshRef.current.scale.z =
    //     THREE.MathUtils.lerp(
    //       meshRef.current.scale.z,
    //       paramsFragments?.scaled?.value ? 1 : myScaleRef.current,
    //       0.15
    //     );

    // paramsFragments?.scaled?.value
    //   ? meshRef.current.scale.lerp(vecScaleInit.set(1, 1, 1), 0.15)
    //   : meshRef.current.scale.lerp(
    //       vecScaleFill.set(
    //         myScaleRef.current,
    //         myScaleRef.current,
    //         myScaleRef.current
    //       ),
    //       0.15
    //     );
  });

  return (
    <group
      {...props}
      dispose={null}
      // dispose={true}
      name={`${filename}_5K`}
      rotation={[rotX, rotZ, rotY]}
    >
      {listMeshes.map((mesh, index) => (
        <mesh
          key={index}
          geometry={mesh.geometry}
          ref={meshRef}
          name={`${filename}_5K_mesh`}
        >
          <meshStandardMaterial ref={matRef} map={material.map} />
        </mesh>
      ))}
    </group>
  );
}
